<div class="container-style row mx-0">
  <form novalidate [formGroup]="formAccountingModel" errorTailor class="w-100">
    <div class="my-2">
      <div class="row">
        <div class="col d-flex justify-content-start">
          <app-navigation (buttonClick)="getButtonClick($event)" class="d-flex"></app-navigation>
        </div>
        <div class="col d-flex justify-content-end align-items-center">
          <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'danger'"
            (onClick)="deleteAccountingModel()"></app-custom-button>
        </div>
        <hr class="my-1" />
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <app-custom-audit-info [userNameCreate]="accountingModelContract.userNameCreate"
            [createDate]="accountingModelContract.createDate"
            [userNameUpdate]="accountingModelContract.userNameUpdate"
            [updateDate]="accountingModelContract.updateDate"
            [reserveSpace]="true"></app-custom-audit-info>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col field-consecutive">
          <app-custom-input-number formControlName="consecutive" [labelText]="'Modelo'" [required]="true"
            [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
        </div>
        <div class="col field-description">
          <app-custom-input-text formControlName="description" [labelText]="'Descripción'"></app-custom-input-text>
        </div>
        <div class="field-save d-flex align-items-end pt-2">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined" [disabled]="disabledForm"
            (onClick)="send()"></app-custom-button>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="p-0 mt-2">
  <app-accounting-model-detail [accountingModelModel]="accountingModelContract" [disabledDetail]="disabledDetail"
    [updateListDetail]="updateListDetail" (updateList)="getUpdateListDetail()"></app-accounting-model-detail>
</div>